var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveTrafficWeatherEvent = function SvgLiveTrafficWeatherEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36A1E9",
    stroke: "#0089D1",
    strokeMiterlimit: 10,
    d: "M12.009 22.08c5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10s-10 4.477-10 10c0 5.522 4.477 10 10 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.08 9.937c.18.062.358.151.527.267.375.277.608.643.697 1.099.098.544.027 1.071-.295 1.544a1.781 1.781 0 0 1-1.34.804c-.088.009-.187.018-.285.018h-6.34a2.58 2.58 0 0 1-.9-.143c-.563-.206-.965-.59-1.224-1.125-.313-.67-.348-1.357-.063-2.045A2.181 2.181 0 0 1 8.045 9.17c.09-.036.187-.072.286-.098.026 0 .035-.018.044-.054a2.475 2.475 0 0 1 1.697-2.259 2.63 2.63 0 0 1 1.232-.125c.625.09 1.143.375 1.553.857.063.072.125.16.188.241.018.027.036.036.071.027a2.289 2.289 0 0 1 1.384.063c.777.294 1.286.839 1.491 1.651.036.152.054.313.08.474z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.37,
    d: "M8.295 14.839v1.348M10.67 16.187v1.357M13.34 14.839v1.348M15.723 16.187v1.357"
  })));
};
export default SvgLiveTrafficWeatherEvent;